<template>
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <!-- Search bar (top half) -->
    <rect x="6" y="6" width="36" height="6" rx="2" stroke="#666666" stroke-width="1.5" fill="none" />
    <circle cx="11" cy="9" r="1.5" stroke="#666666" stroke-width="1.5" fill="none" />
    <line x1="12.5" y1="10.5" x2="14" y2="12" stroke="#666666" stroke-width="1.5" stroke-linecap="round" />
    <!-- Divider -->
    <line x1="6" y1="16" x2="42" y2="16" stroke="#E5E5E5" stroke-width="1" />
    <!-- Grid cells (matrix) -->
    <rect x="6" y="20" width="8" height="5" rx="1" fill="#D6D6D6" />
    <rect x="16" y="20" width="8" height="5" rx="1" fill="#D6D6D6" />
    <rect x="26" y="20" width="8" height="5" rx="1" fill="#D6D6D6" />
    <rect x="36" y="20" width="6" height="5" rx="1" fill="#D6D6D6" />
    <rect x="6" y="28" width="8" height="5" rx="1" fill="#D6D6D6" />
    <rect x="16" y="28" width="8" height="5" rx="1" fill="#D6D6D6" />
    <rect x="26" y="28" width="8" height="5" rx="1" fill="#D6D6D6" />
    <rect x="36" y="28" width="6" height="5" rx="1" fill="#D6D6D6" />
    <rect x="6" y="36" width="8" height="5" rx="1" fill="#D6D6D6" />
    <rect x="16" y="36" width="8" height="5" rx="1" fill="#D6D6D6" />
    <rect x="26" y="36" width="8" height="5" rx="1" fill="#D6D6D6" />
    <rect x="36" y="36" width="6" height="5" rx="1" fill="#D6D6D6" />
  </svg>
</template>
